import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { CompanyModel } from "./Company";
import { AddressModel } from "./Address";
import { TenantUserFields } from "../TenantUserFields";
import { UserJobExperienceModel } from "./JobExperience";

enum GenderEnum {
  female = "F",
  male = "M",
  other = "U",
}


export class UserProfileModel extends Model  {
    key: string = "";
    initials: string = "";
    first_name: string = "";
    preposition: string = "";
    last_name: string = "";
    fullName: string = "";
    gender: GenderEnum = GenderEnum.other;
    email: string = "";
    phone: string = "";
    mobile: string = "";
    type:number = 0;
    company:CompanyModel|null = null;
    address: AddressModel[] = [];
    companyFields?: TenantUserFields;
    userfields: TenantUserFields = new TenantUserFields();
    jobexperience: UserJobExperienceModel = new UserJobExperienceModel();
    roles: any[] = [];

    constructor(data = null, usertype = null) {
        super(data);
        if(data) {
            this.createModel(data);
        }
    }

    public addCompany() {
        let company:CompanyModel = new CompanyModel();

        return company;

    }

      createAddress =(data = null) => {
          let address = new AddressModel(data);
          this.address.push(address);
          
          //this.company_address.push( address );
      }    
}
